import React from 'react'


const NavBar = () => {
    return (
        <div className='shadow-lg px-[4%] py-[5px]' >
            <div className='text-center ' >
            <h1 className='font-QMedium my-5 text-[25px] max-[500px]:text-[21px] max-[400px]:text-[18px] text-[#021763] ' >{process.env.REACT_APP_COMPANY_NAME}</h1>
            </div>
        </div>
    )
}

export default NavBar